import { useState } from 'react';
import AddRestaurantNew from '../AddRestaurantNew';
import AddGrocery from './Grocery';
import { COLORS } from '../../../theme/themeConstants';
import AddPharmacy from './Pharmacy';
import { useAllMerchant } from '../../Query/MerchantQuery';
import { useAllCategory } from '../../Query/CategoryQuery';
type AddRestaurantProps = {
  onCancel: () => void;
  storeType?: string;
  isEdit?: boolean;
  isEditClose?: () => void;
};
const SelectStore = ({ onCancel, isEdit, storeType, isEditClose }: AddRestaurantProps) => {
  const [storeTypes, setStoreType] = useState(isEdit ? storeType : "");
  const storeOptions = ['Restaurant', 'GroceryStore', 'PharmacyStore'];

  const isReadyToFetch = !!storeTypes;

  const { data: merchantData, isLoading } = useAllMerchant(
    { initialData: { storeType: storeTypes }, },
    { enabled: isReadyToFetch }
  );

  const { data: categoryData, isLoading: load } = useAllCategory(
    { initialData: { storeType: storeTypes } },
    { enabled: isReadyToFetch }
  );
  
  const merchantList = merchantData ?? [];

  return (
    <div style={{ padding: '1rem' }}>
      {/* Label and Select Dropdown aligned like the image */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1rem',
          marginLeft: '117px',
        }}
      >
        <label
          htmlFor="storeType"
          style={{
            width: '125px',
            fontWeight: 500,
            fontSize: '14px',
            color: COLORS.text.primary,
            fontFamily: 'livvic',
          }}
        >
          Select Store Type: <span style={{ color: 'red' }}>*</span>
        </label>
        <select
          id="storeType"
          value={storeTypes}
          onChange={(e) => setStoreType(e.target.value)}
          disabled={isEdit}
          style={{
            marginLeft: '13px',
            padding: '8px 12px',
            fontSize: '14px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '396px',
            backgroundColor: '#fff',
            appearance: 'none',
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23999' stroke-width='1.5'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '12px',
          }}
        >
          <option value="">-- Select --</option>
          {storeOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      {/* Conditional rendering of store-specific forms */}
      {/* {!storeTypeOnEdit && storeType === 'Restaurant' && (
        <div style={{ marginTop: '2rem' }}>
          <AddRestaurantNew onCancel={onCancel} storeType={storeType} merchantList={merchantList}/>
        </div>
      )} */}

      {storeTypes === 'Restaurant' && (
        <div style={{ marginTop: '2rem' }}>
          {!isEdit && (
            isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'gray',
                  fontSize: '14px',
                  fontFamily: 'Livvic',
                }}
              >
                Loading...
              </div>
            ) : merchantList && merchantList.length > 0 ? (
              <AddRestaurantNew
                onCancel={onCancel}
                storeType={storeTypes}
                merchantList={merchantList}
                categoryData={categoryData}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'red',
                  fontSize: '14px',
                  fontFamily: 'Livvic',
                }}
              >
                No merchants found for this store type.
              </div>
            )
          )}
        </div>
      )}


      {storeTypes === 'GroceryStore' && (
        <div style={{ marginTop: '2rem' }}>
          {!isEdit ? (
            isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'gray',
                  fontSize: '14px',
                  fontFamily: 'Livvic',
                }}
              >
                Loading...
              </div>
            ) : merchantList && merchantList.length > 0 ? (
              <AddGrocery
                onCancel={onCancel}
                storeType={storeTypes}
                merchantList={merchantList}
                categoryData={categoryData}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'red',
                  fontSize: '14px',
                  fontFamily: 'Livvic',
                }}
              >
                No merchants found for this store type.
              </div>
            )
          ) : isLoading && load ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'gray',
                fontSize: '14px',
                fontFamily: 'Livvic',
              }}
            >
              Loading...
            </div>
          ) : merchantList && merchantList.length > 0 ? (
            <AddGrocery
              onCancel={isEditClose ?? (() => { })}
              storeType={storeTypes}
              merchantList={merchantList}
              categoryData={categoryData}
            />
          ) : null}
        </div>
      )}


      {storeTypes === 'PharmacyStore' && (
        <div style={{ marginTop: '2rem' }}>
          {!isEdit ? (
            isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'gray',
                  fontSize: '14px',
                  fontFamily: 'Livvic',
                }}
              >
                Loading...
              </div>
            ) : merchantList && merchantList.length > 0 ? (
              <AddPharmacy
                onCancel={onCancel}
                storeType={storeTypes}
                merchantList={merchantList}
                categoryData={categoryData}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'red',
                  fontSize: '14px',
                  fontFamily: 'Livvic',
                }}
              >
                No merchants found for this store type.
              </div>
            )
          ) : isLoading && load ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'gray',
                fontSize: '14px',
                fontFamily: 'Livvic',
              }}
            >
              Loading...
            </div>
          ) : merchantList && merchantList.length > 0 ? (
            <AddPharmacy
              onCancel={isEditClose ?? (() => { })}
              storeType={storeTypes}
              merchantList={merchantList}
              categoryData={categoryData}
            />
          ) : null}
        </div>
      )}



    </div>
  );
};

export default SelectStore;
